export default __webpack_public_path__ + "static/media/dashboard-doctor-icon.2ca23d77.svg";